module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-02-9308c676bdc284148112387ad2de3215.svg";